import { useCallback, useMemo, useState } from 'react'
import useQuery from '@client/utils/useQuery'

type UseSidebarQueryListArgs<TArgs> = {
    queryFn: Function
    args: TArgs
    rowsPath?: string // default: 'rows'
}

export default function useSidebarQueryList<TRow, TArgs extends object>({
    queryFn,
    args,
    rowsPath = 'rows',
}: UseSidebarQueryListArgs<TArgs>) {
    const [refreshCounter, setRefreshCounter] = useState(0)

    const { loading, error, data } = useQuery(queryFn, {
        args,
        refreshCounter,
    })

    const rows = useMemo<TRow[]>(() => {
        const r = data?.[rowsPath]
        return Array.isArray(r) ? r : []
    }, [data, rowsPath])

    const refetch = useCallback(() => {
        setRefreshCounter((c) => c + 1)
    }, [])

    return { rows, loading, error, data, refetch }
}
